module.exports = __webpack_public_path__ + "static/media/homePicture.f214f5a0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/homePicture.jpg
// module id = 387
// module chunks = 0